/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Faq_Q1Inputs */

const en_formatter_faq_q1 = /** @type {(inputs: Formatter_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What indentation options are available?`)
};

const ko_formatter_faq_q1 = /** @type {(inputs: Formatter_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`어떤 들여쓰기 옵션을 사용할 수 있나요?`)
};

const ja_formatter_faq_q1 = /** @type {(inputs: Formatter_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どのインデントオプションが使えますか？`)
};

/**
* | output |
* | --- |
* | "What indentation options are available?" |
*
* @param {Formatter_Faq_Q1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_faq_q1 = /** @type {((inputs?: Formatter_Faq_Q1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Faq_Q1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_faq_q1(inputs)
	if (locale === "ko") return ko_formatter_faq_q1(inputs)
	return ja_formatter_faq_q1(inputs)
});